import API_KEY from '.';

export const getManufacturerInfoApi = () => {
  return API_KEY.URL.get(`${API_KEY.path.manufacturer}`);
};
